module.exports = __webpack_public_path__ + "static/img/side-bar.c5660bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/freetarget/side-bar.png
// module id = L+ua
// module chunks = 1